import { Component } from '@angular/core';

@Component({
  selector: 'app-users-menu-permissions',
  standalone: true,
  imports: [],
  templateUrl: './users-menu-permissions.component.html',
  styleUrl: './users-menu-permissions.component.css'
})
export class UsersMenuPermissionsComponent {

}
